import axios from 'axios'
import { REACT_APP_API } from '../../config'

export const getBranchOfficeByCarLots = async (carLots) => {
    let query = ''
    carLots.forEach(id => {
        query = query + 'car_lot_id[]=' + id + '&'
    });
    // remove last '&'
    query = query.slice(0,-1)

    try {
        const { data } = await axios(`${REACT_APP_API}/branchoffices?${query}`)
        const groupBranchOffices = {}

        for(let i in data?.data) {
            const branchOffice = data.data[i]
            const name = branchOffice.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            const {id, car_lot_id, name: branchOfficeName} = branchOffice
            if(!groupBranchOffices[name]) {
                groupBranchOffices[name] = {
                    label: branchOfficeName,
                    value: branchOfficeName,
                    id: [id],
                    carLotIds: [car_lot_id]
                }
            } else {
                groupBranchOffices[name].id = [...groupBranchOffices[name].id, id]
                groupBranchOffices[name].carLotIds = [...groupBranchOffices[name].carLotIds, car_lot_id]
            }
        }
    
        return Object.values(groupBranchOffices)
    } catch (error) {
        console.log(`Error getBranchOfficeByCarLots SV `, error)
        return error;
    }
}